import './App.css';
import React , {useEffect} from "react";
import Header from './Header';
import Home from './Home';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Checkout from './Checkout';
import Login from './Login';
import { auth } from './firebase';
import { useStateValue } from './StateProvider';

function App() {

  const [{}, dispatch] = useStateValue();

  useEffect(() => {
    auth.onAuthStateChanged(authUser => {
      console.log(`The User Is -->`,authUser);
      if(authUser)
      {
        //user logged in
        dispatch({
          type: 'SET_USER',
          user: authUser
        })
      }
      else{
        // user Logged Out
        dispatch({
          type: 'SET_USER',
          user: null
        })
      }
    })

    
  }, [])

  return (

      <Router>
        <div className="App">
        
        <Switch>
        <Route path="/login">            
            <Login/>
          </Route>
          <Route path="/checkout"> 
          <Header />           
            <Checkout/>
          </Route>
          <Route path="/">
             <Header />
            <Home />
          </Route>         
        </Switch>           
        </div>
      </Router>
  );
}

export default App;
